import { transition } from '@helpers/animate';
import brand from '@helpers/brand';
import { fluid } from '@helpers/fluid';
import { siteWide } from '@helpers/grid';
import { Device, from } from '@helpers/media';
import { linkReversed, paragraphSmall } from '@helpers/typography';
import { rgba } from 'polished';
import styled from 'styled-components';
const Container = styled.footer `
  padding: ${fluid(64, 80)} 0 64px;
  background-color: ${brand.primary.blue};
  color: ${brand.global.white};

  @media ${from(Device.Tablet)} {
    padding: ${fluid(64, 80)} 0 40px;
  }
`;
const Inner = styled.div `
  ${siteWide};
`;
const FooterTop = styled.div `
  @media ${from(Device.Tablet)} {
    display: flex;
    justify-content: space-between;
    column-gap: ${fluid(40, 80)};
  }
`;
const FooterTopLeft = styled.div `
  max-width: 300px;
`;
const Logo = styled.a `
  ${transition('opacity')};

  display: inline-block;
  height: 64px;
  border-radius: 2px;
  margin-bottom: 32px;

  &:focus-visible {
    outline-style: solid;
    outline-offset: 5px;
    outline-width: 2px;
    outline-color: ${brand.global.white};
  }

  &:focus-visible,
  &:hover {
    opacity: 0.65;
  }

  svg {
    display: block;
    height: 100%;
  }

  @media ${from(Device.Tablet)} {
    height: 80px;
    margin-bottom: 24px;
  }
`;
const Description = styled.p `
  ${paragraphSmall};

  line-height: 1.5em;
  margin-bottom: 0;
`;
const FooterTopRight = styled.div `
  margin-top: 32px;

  @media ${from(Device.MobileLarge)} {
    display: flex;
    column-gap: ${fluid(40, 80)};
  }

  @media ${from(Device.Tablet)} {
    margin-top: 0;
  }
`;
const FooterLinksGroup = styled.div `
  margin-top: 40px;

  @media ${from(Device.MobileLarge)} {
    margin-top: 0;
  }
`;
const FooterLinksGroupTitle = styled.p `
  ${paragraphSmall};

  margin-bottom: ${fluid(16, 24)};
  line-height: 1.5em;
  font-weight: bold;
`;
const FooterLinksGroupList = styled.ul `
  @media ${from(Device.TabletLarge)} {
    &[data-columns='true'] {
      column-count: 2;
      column-gap: 16px;
    }
  }
`;
const FooterLinkItem = styled.li `
  ${paragraphSmall};

  line-height: 1.5em;

  &:not(:last-child) {
    margin-bottom: 8px;
  }

  a {
    ${linkReversed};
    color: ${brand.global.white};
    font-weight: normal;
  }
`;
const FooterBottom = styled.div `
  display: flex;
  justify-content: center;
  flex-direction: column;
  margin-top: 32px;
  padding-top: 32px;
  border-top: 1px solid ${rgba(brand.global.white, 0.3)};

  @media ${from(Device.MobileLarge)} {
    justify-content: space-between;
    flex-direction: row;
  }
`;
const CopyrightText = styled.div `
  text-align: center;

  @media ${from(Device.MobileLarge)} {
    text-align: left;
  }
`;
const SocialLinks = styled.div `
  display: flex;
  justify-content: center;
  align-items: center;
  column-gap: 32px;
  margin-bottom: 32px;
  order: -1;

  @media ${from(Device.MobileLarge)} {
    justify-content: flex-end;
    order: initial;
    column-gap: 16px;
    margin-bottom: 0;
  }
`;
const SocialLink = styled.a `
  ${transition('opacity, transform')};
  color: ${brand.global.white};

  svg {
    height: 20px;
  }

  &:hover {
    opacity: 0.8;
    transform: scale(1.1);
  }
`;
const FooterStyles = {
    Container,
    CopyrightText,
    Description,
    FooterBottom,
    FooterLinkItem,
    FooterLinksGroup,
    FooterLinksGroupList,
    FooterLinksGroupTitle,
    FooterTop,
    FooterTopLeft,
    FooterTopRight,
    Inner,
    Logo,
    SocialLink,
    SocialLinks,
};
export default FooterStyles;
